export default function () {
  const keydownClass = 'c-keyDown';
  const outlineHiddenClass = 'c-outline-hidden';
  const body = window.document.querySelector('body');

  body.classList.add(outlineHiddenClass);

  body.addEventListener('mousedown', () => {
    body.classList.remove(keydownClass);
    body.classList.add(outlineHiddenClass);
  });

  body.addEventListener('keydown', (event) => {
    const keyCode = event.keyCode || event.which;
    if (keyCode === 9) {
      body.classList.add(keydownClass);
      body.classList.remove(outlineHiddenClass);
    }
  });
}
